import type { Resource } from '../types';

export interface FarmingCropDefinition {
    id: Resource;
    name: string;
    level: number;
    xp: number;
    yield: number; // base loot amount
    cost: number;
    duration: number; // in ms
    color: string;
    description: string;
}

export const FARMING_DATA: FarmingCropDefinition[] = [
    // Basic Crops
    { id: 'potato', name: 'Potato', level: 1, xp: 30, yield: 10, cost: 1, duration: 25000, color: '#d97706', description: 'A reliable tuber.' },
    { id: 'carrot', name: 'Carrot', level: 10, xp: 75, yield: 12, cost: 2, duration: 50000, color: '#ea580c', description: 'Good for eyesight.' },
    { id: 'wheat', name: 'Wheat', level: 15, xp: 105, yield: 15, cost: 3, duration: 75000, color: '#fcd34d', description: 'Staple grain.' },
    { id: 'corn', name: 'Corn', level: 25, xp: 150, yield: 18, cost: 5, duration: 100000, color: '#eab308', description: 'Sweet and yellow.' },
    { id: 'hops', name: 'Hops', level: 35, xp: 225, yield: 20, cost: 8, duration: 150000, color: '#15803d', description: 'Bitter flower.' },

    // Advanced / Herbal
    { id: 'herbs', name: 'Herbs', level: 45, xp: 300, yield: 25, cost: 15, duration: 225000, color: '#86efac', description: 'Medicinal properties.' },

    // Exotic
    { id: 'alien_flora', name: 'Alien Flora', level: 60, xp: 750, yield: 35, cost: 50, duration: 300000, color: '#a855f7', description: 'glows in the dark.' },
    { id: 'crystal_tree', name: 'Crystal Tree', level: 80, xp: 3000, yield: 50, cost: 200, duration: 600000, color: '#06b6d4', description: 'Grows pure crystal.' },
];

export const PLOT_UNLOCK_LEVELS = [1, 20, 80];
